import { Box, Button, ErrorMessage, List, ListItem, Strong, xcss } from '@forge/react';
import React from 'react';
const MAX_DISPLAY_SUGGESTIONS = 5;
export function SuggestionsBox(props) {
    const { hasSelection, suggestions, onSelect } = props;
    if (suggestions.length === 0) {
        return null;
    }
    let quantityOfItemsToDisplay = MAX_DISPLAY_SUGGESTIONS;
    if (suggestions.length === MAX_DISPLAY_SUGGESTIONS + 1) {
        quantityOfItemsToDisplay = suggestions.length;
    }
    return (React.createElement(React.Fragment, null,
        suggestions.length === 0 && (React.createElement(ErrorMessage, null, "No available resource that match the selected date and time.")),
        suggestions.length > 0 && (React.createElement(Box, { xcss: xcss({ backgroundColor: 'color.background.information' }), padding: 'space.200' },
            React.createElement(Strong, null, hasSelection
                ? 'Other available resources that match the selected date and time:'
                : 'Available resources that match the selected date and time:'),
            React.createElement(List, { type: 'unordered' },
                suggestions.slice(0, quantityOfItemsToDisplay).map((resource) => (React.createElement(ListItem, { key: resource.value },
                    React.createElement(Button, { appearance: 'default', spacing: 'compact', onClick: () => onSelect(resource.value) }, resource.label)))),
                suggestions.length > quantityOfItemsToDisplay && React.createElement(ListItem, null, "..."))))));
}
